module.exports = __webpack_public_path__ + "img/protokol.f554d828.jpg";